<template>
  <div class="page-keyword">
    <app-page-box title="关键词概况">
      <app-overview-bar>
        <app-overview-bar-item label="前5页排名量" tip="搜索引擎前5页的关键词排名数量；1个关键词在同一搜索引擎有多个排名，计算1个关键词排名量；1个关键词在多个搜索引擎有排名，计算多个排名" :value="stats.fifthPageKeywordsCount"></app-overview-bar-item>
        <app-overview-bar-item label="首页排名量" tip="搜索引擎第1页的关键词排名数量；1个关键词在同一搜索引擎有多个排名，计算1个关键词排名量；1个关键词在多个搜索引擎有排名，计算多个排名" :value="stats.firstPageKeywordsCount"></app-overview-bar-item>
      </app-overview-bar>
    </app-page-box>
    <app-page-box title="关键词趋势">
      <div class="page-keyword__chart-filter">
        <div>
          <el-select
            v-model="chartType"
            @change="handleChartTypeChange"
            placeholder="请选择图表类型"
            size="mini"
          >
            <el-option
              v-for="item in chartTypeOptions"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-button-group>
            <el-button :type="days === 0 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(0)">至今</el-button>
            <el-button :type="days === 30 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(30)">最近30天</el-button>
            <el-button :type="days === 183 ? 'primary' : ''" size="mini" @click="handleDateRangeChange(183)">最近半年</el-button>
          </el-button-group>
          <div class="page-keyword__chart-date-picker">
            <span>自定义&nbsp;&nbsp;</span>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              size="mini"
              style="width: 245px;"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              @change="handleDatePickerChange"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <app-line-chart :chart-data="chartData"></app-line-chart>
    </app-page-box>
    <div class="page-keyword__message">
      <el-alert type="info" title="温馨提示：关键词在搜索引擎的排名可能出现细微浮动，系查询排名时不同IP或细微时间差所致。" show-icon></el-alert>
    </div>
    <app-page-box title="关键词推广明细">
      <div class="page-keyword__filter" slot="tools">
        <el-input v-model="queryObj.keywords" @keyup.enter.native="handleKeywordsChange" size="mini" style="width: 200px;" placeholder="请输入内容">
          <i class="el-input__icon el-icon-search" slot="suffix" @click="handleKeywordsChange"></i>
        </el-input>
      </div>
      <el-table size="mini" :data="detail.list">
        <el-table-column prop="keyword" label="关键词"></el-table-column>
        <el-table-column prop="searchEngine" label="搜索引擎" :formatter="formatSearchEngine"> </el-table-column>
        <el-table-column prop="rank" label="排名"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <a
              class="app-keyword-list__btn-view"
              v-if="scope.row.url"
              :href="scope.row.url"
              target="_blank"
            >查看排名</a>
          </template>
        </el-table-column>
      </el-table>
      <template v-if="detail.total > pageSize">
        <el-pagination
          :total="detail.total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="handlePageChange"
          layout="prev, pager, next"
          background
        ></el-pagination>
      </template>
    </app-page-box>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'
import AppTextHelp from '@/components/AppTextHelp'
import AppLineChart from '@/components/AppLineChart'
import AppOverviewBar, { AppOverviewBarItem } from '@/components/AppOverviewBar'
import searchEngines from '@/assets/maps/searchEngines'
import { getDateRange, getTimestamp } from '@/utils'

export default {
  name: 'Keyword',
  components: {
    AppPageBox,
    AppLineChart,
    AppOverviewBar,
    AppOverviewBarItem
  },

  data () {
    return {
      days: 0,
      dateRange: [],
      chartType: 1,
      chartTypeOptions: [
        { label: '首页排名量', value: 1 },
        { label: '前5页排名量', value: 5 }
      ],
      queryObj: {
        keywords: ''
      },
      page: 1,
      pageSize: 10
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },
    stats () {
      return this.$store.state.account.stats
    },
    chartData () {
      return this.$store.state.keyword.chartData
    },
    detail () {
      return this.$store.state.keyword.detail
    }
  },

  created () {
    this.setDateRange(0)
    this.getChartData()
    this.getKeywords()
  },

  methods: {
    /**
     * 获取图表数据
     */
    getChartData () {
      this.$store.dispatch('getKeywordsChartData', {
        query: {
          uid: this.user.id,
          page_num: this.chartType, // 1：首页, 3：前三页, 5：前5页
          start_time: getTimestamp(this.dateRange[0], 's'),
          end_time: getTimestamp(this.dateRange[1], 's')
        }
      })
    },

    getKeywords () {
      const queryString = this.getQueryString()
      const orderString = this.getOrderString()

      this.$store.dispatch('getKeywords', {
        query: {
          query: queryString,
          orders: orderString,
          offset: (this.page - 1) * this.pageSize,
          limit: this.pageSize
        }
      })
    },

    getQueryString () {
      const { queryObj } = this
      let queryString = `uid:${this.user.id}`

      // 关键词
      if (queryObj.keywords) {
        const keywords = queryObj.keywords.split(' ')
          .filter(item => !!item)
          .join(' AND ')

        queryString += ` AND keyword:(${keywords})`
      }

      return queryString
    },

    getOrderString () {
      let orderString = ''

      orderString += 'degree:desc,keyword_size:asc'
      return orderString
    },

    setDateRange (days) {
      let range = null

      if (days) {
        range = getDateRange(days)
      } else {
        range = { startTime: new Date(2018, 0, 1), endTime: new Date() }
      }

      this.dateRange = [ range.startTime.toISOString(), range.endTime.toISOString() ]
      this.days = days
    },

    resetPage () {
      this.page = 1
    },

    handleChartTypeChange () {
      this.getChartData()
    },

    handleDateRangeChange (days) {
      this.setDateRange(days)
      this.getChartData()
    },

    handleDatePickerChange () {
      this.days = null
      this.getChartData()
    },

    renderHeader (createElement, { column }) {
      const pair = column.label.split('|')
      const content = createElement(AppTextHelp, {
        props: {
          text: pair[0],
          tip: pair[1] || 'Why?'
        }
      })

      return content
    },

    formatSearchEngine (row, column, cellValue, index) {
      return searchEngines.getLabelById(cellValue) || '-'
    },

    handleKeywordsChange () {
      this.resetPage()
      this.getKeywords()
    },

    handlePageChange (page) {
      this.page = page
      this.getKeywords()
    }
  }
}
</script>

<style lang="scss">
.page-keyword {
  .el-pagination {
    margin-top: 15px;
    text-align: right;
  }

  &__chart-filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__chart-date-picker {
    display: inline-block;
    margin-left: 30px;
  }

  &__message {
    margin-bottom: 15px;
    .el-alert {
      background-color: rgba($primary-color, .1);
      color: #666;
    }
  }
}
</style>
